module.exports = __webpack_public_path__ + "static/media/open.7ee16df0.svg";